module.exports = __webpack_public_path__ + "images/chat.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader/dist/cjs.js?name=images/[name].[ext]!./src/images/email/chat.png
// module id = ./node_modules/file-loader/dist/cjs.js?name=images/[name].[ext]!./src/images/email/chat.png
// module chunks = 21